// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/TokenWalletModal/TokenWalletModal.css
// module id = 2380
// module chunks = 0